import { CharterFareInventory } from '~/components/Flights/Charter/charter.types';

import * as TimeService from '~/services/TimeService';

type Option<Value> = { label: string; value: Value };

export const stayOptions: Array<Option<number>> = [
  { label: '5 nights', value: 5 },
  { label: '12 nights', value: 12 },
];

export const cabinOptions: Array<Option<CharterFareInventory['cabinClass']>> = [
  { label: 'Business', value: 'BUSINESS' },
  { label: 'Economy', value: 'ECONOMY' },
];

export const monthOptions: Array<Option<number>> = TimeService.getMonths().map((label, index) => ({
  label,
  value: index + 1,
}));

export const defaultMonths = monthOptions.map((option) => option.value);

export const pageSizeOptions = [10, 20, 50, 100];

const csvHeaders = [
  'Direction',
  'Stay (nights)',
  'Departure Date',
  'Departure Time',
  'Arrival Date',
  'Arrival Time',
  'Departure Airport Code',
  'Arrival Airport Code',
  'Cabin Class',
  'Booking Class',
  'Total Bookable Seats',
  'Sold Seats',
  'Blocked Seats',
  'Available Seats',
  'Currency',
  'Seat Price (Adult)',
  'Seat Price (Child)',
  'Seat Price (Infant)',
] as const;
export type CharterInventoryCsvHeader = (typeof charterInventoryCsvHeaders)[number];
export const charterInventoryCsvHeaders = [...csvHeaders];
